import { languages as langs, type TLanguageCode } from 'countries-list';
import { languages } from 'react-circle-flags';

export interface Language {
  /**
   * Language name in English (e.g., "Ukrainian").
   */
  name: string;

  /**
   * Native language name (e.g., "українська"). Used in dropdown display.
   */
  label: string;

  /**
   * ISO 639 alpha-2 code (e.g., `uk`).
   */
  value: string;
}

const generateLanguages = (): Record<string, Language> => {
  const result: Record<string, Language> = {};

  Object.keys(languages).forEach(code => {
    if (code in langs) {
      const langData = langs[code as TLanguageCode];
      result[code] = {
        name: langData.name,
        label: langData.native,
        value: code,
      };
    }
  });

  return result;
};

export const LANGUAGES_OBJ: Record<string, Language> = generateLanguages();

export const LANGUAGES = Object.values(LANGUAGES_OBJ);
